export default {
    tagged: '4.0.0-ba3d24f',
    version: '4.0.0',
    revision: 'ba3d24f',
};
//# sourceMappingURL=version.js.map